import React, { useCallback, useEffect, useRef, useState } from "react";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsMap from "highcharts/modules/map";
import "../../src/components/Report/map-report/india-map/india-map.componentN.scss";
import "./map.scss";
import { india } from "../assets/maps/all-india";
import { district_map } from "../assets/maps/district_map";
import stateIdData from "../mapData/mapDatalatLong.json";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import MapColorLabel from "./MapColorLabel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  fetchDashboardData,
  fetchMaptatsData,
  fetchMaptatsOtherData,
  fetchSchoolStatsData,
  fetchSchoolStatsIntData,
  fetchStudentStatsData,
  fetchStudentStatsIntData,
  fetchTeachersStatsData,
  fetchTeachersStatsIntData,
} from "../redux/thunks/dashboardThunk";
import { fetchArchiveServicesGraphSchoolData } from "../redux/thunks/archiveServicesThunk";
import {
  nationalWiseName,
  specificSWiseregionType,
  modifiedFilterObjForReset,
  modifiedFilterObjResetDashboard,
} from "../constants/constants";
import { allFilter } from "../redux/slice/schoolFilterSlice";
import { useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { setBackstate, setIsIndiaClicked } from "../redux/slice/mapSlice";
import { removeAllDistrict } from "../redux/thunks/districtThunk";
import { removeAllBlock } from "../redux/thunks/blockThunk";
import { keyLabels, keyMap } from "../mapModels/mapModels";
highchartsMap(Highcharts);
localStorage.setItem("backstate", "All India/National");
const Map = () => {
  console.log('------------')
  const dispatch = useDispatch();
  const location = useLocation();
  // const [backstate, setBackstate] = useState(nationalWiseName);
  const backstate = useSelector((state) => state?.mapData?.backstate);
  const [MergeDataFromAllVariable, setMergeDataFromAllVariable] = useState([]);
  const dashIntDataMap = useSelector(
    (state) => state?.MapStats?.data?.data,
    shallowEqual
  );
  const dashData = useSelector(
    (state) => state?.MapStatsPercentage?.data?.data,
    shallowEqual
  );

  console.log('8888888888888888888')
  console.log('dashData', dashData)
  const dashIntSchoolsDataMap = useSelector(
    (state) => state?.MapSchoolsStats?.data?.data,
    shallowEqual
  );


  const dashIntTeacherDataMap = useSelector(
    (state) => state?.MapTeacherStats?.data?.data,
    shallowEqual
  );
const ChangeKeydashIntTeacherDataMap= dashIntTeacherDataMap?.map((key)=>key.totTchM)
  const dashIntTeacherTrainedDataMap = useSelector(
    (state) => state?.MapTeacherTrainedStats?.data?.data,
    shallowEqual
  );
 
  const dashIntTeacherTrainedDataMapWithKey = dashIntTeacherDataMap.map((item) => {
    const { totTchF, totTchM, ...rest } = item;  
    return {
      ...rest,                          
      totTchFModify: totTchF,            
      totTchMModify: totTchM             
    };
  });
  
  const dashIntStudentsGPRDataMap = useSelector(
    (state) => state?.MapStudentsStats?.data?.data,
    shallowEqual
  );

  const dashIntStudentsGPIDataMap = useSelector(
    (state) => state?.MapStudentsGPIStats?.data?.data,
    shallowEqual
  );

  const handleSchemesEvent = useSelector(
    (state) => state?.mapData?.grossEData,
    shallowEqual
  );

  const selectedState = useSelector(
    (state) => state?.mapData?.stateName,
    shallowEqual
  );

  console.log('selectedState', selectedState)

  const selectedStateForCallAPI = localStorage.getItem("backstate");
  const maxYearId = localStorage.getItem("acData");
  const parsedACData = JSON.parse(maxYearId);
  const selectYearId = parsedACData?.yearId;
  const [selectedEnrollmentToilet, setSelectedEnrollmentToilet] =
    useState("middle");
  const [selectedEnrollmentType, setSelectedEnrollmentType] =
    useState("middle");
  const [selectedDropoutType, setSelectedDropoutType] = useState("preparatory");
  const [selectedTransitionRate, setSelectedTransitionRate] = useState(
    "preparatoryToMiddle"
  );
  const [selectedPupilTeacherRatio, setSelectedPupilTeacherRatio] =
    useState("pupilPreparatory");
  const [selectedToilet, setSelectedToilet] = useState("girls");
  const [selectedNatureOfApponitmentType, setSelectedNatureOfApponitmentType] =
    useState("female");

  const [selectedTrainedTeacherCWSNType, setSelectedTrainedTeacherCWSNType] =
    useState("female");

  const [selectedTrainedTeacherCompType, setSelectedTrainedTeacherCompType] =
    useState("female");
  const [selectedGPIType, setSelectedGPIType] = useState("gpiprimary");
  const [selectedGERType, setSelectedGERType] = useState(
    "gerDropoutUpperPrimary"
  );
  const grossEData = useSelector((state) => state?.mapData?.grossEData);
  const resetMap = useSelector((state) => state?.mapData?.resetMap);
  const isIndiaClicked = useSelector((state) => state?.mapData?.isIndiaClicked);
  const [updateGrossEData, setUpdateGrossEData] = useState(
    "Gross Enrollment Ratio"
  );
  const headerSlice = useSelector((state) => state.header);
  const [resetTrigger, setResetTrigger] = useState(false);
  const [loading, setLoading] = useState(true);
  const [backstatesPreventApiCall, setBackstatesPreventApiCall] =
    useState("india");
  const [udiseStateCode, setUdiceStateCode] = useState("");
  const schoolFilter = useSelector(
    (state) => state?.schoolFilter,
    shallowEqual
  );
  let filterObj = structuredClone(schoolFilter);
  const normalize = useCallback(
    (str) => str.trim().toLowerCase().replace(/&/g, "").replace(/\s+/g, " "),
    []
  );

  console.log('india', india)
  const intialMapOptions = {
    chart: {
      map: india,
      events: {
        contextmenu: function (e) {
          e.preventDefault();
        },
      },
      // marginTop: 25,
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    mapNavigation: {
      enabled: false,
    },
    tooltip: {
      useHTML: true,
      backgroundColor: "#303841",
      style: {
        color: "white",
        fontSize: "14px",
      },
    },
    series: [
      {
        name: "State",
        type: "map",
        mapData: india,
        allowPointSelect: true,
        cursor: "pointer",
        borderColor: "#000000",
        color: "#fcae91",
        opacity: 1,
        allAreas: true,
        dataLabels: {
          enabled: false,
          format: "{point.name}",
        },
        data: MergeDataFromAllVariable,
        events: {
          click: (e) => {
            dispatch(setBackstate(e.point["hc-key"]));
            setBackstatesPreventApiCall(e.point["hc-key"]);
            localStorage.setItem("backstate", e.point["hc-key"]);
            if (backstatesPreventApiCall === "India") {
              dispatch(setIsIndiaClicked(false));
            } else {
              dispatch(setIsIndiaClicked(true));
            }
          },
        },
      },
    ],
  };
  const [mapOptions, setMapOptions] = useState(intialMapOptions);
  console.log('MergeDataFromAllVariable', MergeDataFromAllVariable)
  useEffect(() => {
    if (backstate === nationalWiseName) {
      setMapOptions((prevOptions) => ({
        ...prevOptions,
        series: [
          {
            ...prevOptions.series[0],
            data: MergeDataFromAllVariable,
          },
        ],
      }));
    }
  }, [MergeDataFromAllVariable]);

  useEffect(() => {
    if (MergeDataFromAllVariable.length > 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [MergeDataFromAllVariable]);

  useEffect(() => {
    if (selectedState === nationalWiseName) {
      dispatch(setBackstate("All India/National"));
      setBackstatesPreventApiCall("India");
      setMapOptions(intialMapOptions);
    } else if (selectedState) {
      dispatch(setBackstate(selectedState));
      setBackstatesPreventApiCall("selectedState");
      setState(selectedState);
    }
  }, [selectedState]);

  useEffect(() => {
    if (grossEData === "gross_enrollment_ratio") {
      setUpdateGrossEData("Gross Enrollment Ratio");
    } else if (grossEData === "dropout_rate") {
      setUpdateGrossEData("Dropout Rate");
    } else if (grossEData === "transition_rate") {
      setUpdateGrossEData("Transition Rate");
    } else if (grossEData === "pupil_teacher_ratio") {
      setUpdateGrossEData("Pupil Teacher Ratio");
    } else if (grossEData === "schools_with_drinking_water") {
      setUpdateGrossEData("Schools with Drinking Water");
    } else if (grossEData === "schools_with_electricity_connection") {
      setUpdateGrossEData("Schools with Electricity Connection");
    } else if (grossEData === "school_with") {
      setUpdateGrossEData("Schools with");
    } else if (grossEData === "toilet") {
      setUpdateGrossEData("Schools with");
    } else if (grossEData === "libraries") {
      setUpdateGrossEData("Schools with Libraries");
    } else if (grossEData === "ramp") {
      setUpdateGrossEData("Schools with Ramp");
    } else if (grossEData === "nature_of_appointment") {
      setUpdateGrossEData("Nature of appointment Regular");
    } else if (grossEData === "trained_teacher_for_cwsn") {
      setUpdateGrossEData("Trained Teachers for CWSN");
    } else if (grossEData === "teacher_trained_&_teaching_through_computer") {
      setUpdateGrossEData("Teachers trained & teaching through computer");
    } else if (grossEData === "gender_parity_index") {
      setUpdateGrossEData("GPI(Gender Parity Index)");
    } else if (grossEData === "dropout_ratio") {
      setUpdateGrossEData("Dropout Rate");
    }
    
  }, [grossEData]);

  const getSelectedType = useCallback(() => {
    switch (handleSchemesEvent) {
      case "gross_enrollment_ratio":
        return selectedEnrollmentType;
      case "dropout_rate":
        return selectedDropoutType;
      case "transition_rate":
        return selectedTransitionRate;
      case "pupil_teacher_ratio":
        return selectedPupilTeacherRatio;
      case "school_with":
        return selectedEnrollmentToilet;
      case "toilet":
        return selectedToilet;
      case "nature_of_appointment":
        return selectedNatureOfApponitmentType;
      case "trained_teacher_for_cwsn":
        return selectedTrainedTeacherCWSNType;
      case "teacher_trained_&_teaching_through_computer":
        return selectedTrainedTeacherCompType;
        case "gender_parity_index":
          return selectedGPIType;
          case "dropout_ratio":
            return selectedGERType;
      default:
        return null;
    }
  }, [
    handleSchemesEvent,
    selectedEnrollmentType,
    selectedDropoutType,
    selectedTransitionRate,
    selectedPupilTeacherRatio,
    selectedEnrollmentToilet,
    selectedToilet,
    selectedNatureOfApponitmentType,
    selectedTrainedTeacherCWSNType,
    selectedTrainedTeacherCompType,
    selectedGPIType,
    selectedGERType
  ]);

  const getFilteredKey = useCallback(
    (handleSchemesEvent, selectedType) => {
      return (
        keyMap[handleSchemesEvent]?.[selectedType] ||
        keyMap[handleSchemesEvent]?.default ||
        null
      );
    },
    [handleSchemesEvent]
  );

  const getColorFromData = useCallback(
    (additionalData) => {
      const getColor = (a, thresholds, reversed = false) => {
        if (reversed) {
          return a <= thresholds[0]
            ? "#c1d0b5"
            : a <= thresholds[1]
            ? "#e3d1f8"
            : a <= thresholds[2]
            ? "#ffeda0"
            : "#fcae91";
        } else {
          return a <= thresholds[0]
            ? "#fcae91"
            : a <= thresholds[1]
            ? "#ffeda0"
            : a <= thresholds[2]
            ? "#e3d1f8"
            : "#c1d0b5";
        }
      };

      let a = 0;
      const selectedKey = getFilteredKey(handleSchemesEvent, getSelectedType());
      if (selectedKey) {
        a = additionalData[selectedKey] || 0;
      }

      let color = "#FFFFFF";
      switch (handleSchemesEvent) {
        case "gross_enrollment_ratio":
          color = getColor(a, [50, 60, 70]);
          break;
        case "dropout_rate":
          color = getColor(a, [5, 10, 15], true);
          break;
        case "dropout_ratio":
          color = getColor(a, [3, 5, 8], true);
          break;
        case "transition_rate":
          color = getColor(a, [85, 90, 95]);
          break;
        case "pupil_teacher_ratio":
          color = getColor(a, [30, 35, 40], true);
          break;
        case "schools_with_drinking_water":
          color = getColor(a, [85, 90, 95]);
          break;
        case "schools_with_electricity_connection":
          color = getColor(a, [70, 80, 90]);
          break;
        case "school_with":
          color = getColor(a, [85, 90, 95]);
          break;
        case "toilet":
          color = getColor(a, [85, 90, 95]);
          break;
        case "libraries":
          color = getColor(a, [51, 71, 90]);
          break;
        case "ramp":
          color = getColor(a, [51, 71, 90]);
          break;
        case "nature_of_appointment":
          color = getColor(a, [29.9, 49.9, 80]);
          break;
        case "trained_teacher_for_cwsn":
          color = getColor(a, [2.9, 4.9, 8]);
          break;
        case "teacher_trained_&_teaching_through_computer":
          color = getColor(a, [30, 50, 80]);
          break;
          case "gender_parity_index":
            color = getColor(a, [0.90, 0.95, 0.99]);
            break;
          case "dropout_ratio":
            color = getColor(a, [3, 5, 8],true);
            break;
        default:
          break;
      }

      return { color };
    },
    [handleSchemesEvent, getFilteredKey, getSelectedType]
  );

  useEffect(() => {
    let dataToUse = [];

    if (headerSlice.headerName === "Education Dashboard") {
      dataToUse = [dashData, dashIntDataMap];
    } else if (headerSlice.headerName === "School Dashboard") {
      dataToUse = [dashIntSchoolsDataMap];
    } else if (headerSlice.headerName === "Teacher Dashboard") {
      dataToUse = [dashIntTeacherTrainedDataMap, dashIntTeacherTrainedDataMapWithKey];
    }  else if (headerSlice.headerName === "Student Dashboard") {
      dataToUse = [dashIntStudentsGPRDataMap, dashIntStudentsGPIDataMap];
    }

    if (dataToUse.every((data) => data?.length > 0)) {
      const normalize = (str) =>
        str.trim().toLowerCase().replace(/&/g, "").replace(/\s+/g, " ");

      const selectedType = getSelectedType();
      const updatedSeriesData = india.features.map((feature) => {
        const regionName = normalize(feature.properties.name);
        const additionalData = { regionName: feature.properties.name };

        dataToUse.forEach((dataList) => {
          const matchingData = dataList.find(
            (item) => normalize(item.regionName) === regionName
          );

          if (matchingData) {
            Object.keys(matchingData).forEach((key) => {
              if (key === "regionName") {
                additionalData[key] = matchingData[key];
              } else {
                additionalData[key] = parseFloat(matchingData[key] || 0);
              }
            });
          }
        });

        const color = getColorFromData(additionalData).color;

        return {
          "hc-key": feature.properties["hc-key"],
          name: feature.properties.name,
          additionalData,
          color,
        };
      });

      const filteredData = updatedSeriesData.map((item) => {
        const keyToInclude = getFilteredKey(handleSchemesEvent, selectedType);
        const filteredAdditionalData = keyToInclude
          ? { [keyToInclude]: item.additionalData[keyToInclude] }
          : {};

        return {
          ...item,
          additionalData: filteredAdditionalData,
        };
      });

      setMergeDataFromAllVariable(filteredData);
    }
  }, [
    dashData,
    dashIntDataMap,
    dashIntSchoolsDataMap,
    dashIntTeacherDataMap,
    dashIntTeacherTrainedDataMap,
    dashIntStudentsGPRDataMap,
    dashIntStudentsGPIDataMap,
    headerSlice.headerName,
    handleSchemesEvent,
    selectedEnrollmentType,
    selectedDropoutType,
    selectedTransitionRate,
    selectedPupilTeacherRatio,
    selectedEnrollmentToilet,
    getColorFromData,
    getFilteredKey,
    getSelectedType,
    resetTrigger,
  ]);

  useEffect(() => {
    if (backstate === nationalWiseName) {
      setMapOptions((prevMapOptions) => ({
        ...prevMapOptions,
        tooltip: {
          ...prevMapOptions.tooltip,
          formatter: function () {
            const normalize = (str) =>
              str.trim().toLowerCase().replace(/&/g, "").replace(/\s+/g, " ");

            const point = this.point;
            const regionName = normalize(point.name);
            const matchingRegionData = MergeDataFromAllVariable.find(
              (item) => normalize(item.name) === regionName
            );

            // Tooltip content starts with the region name
            let tooltipContent = `<div class="tooltip-content"><strong>${"State"}:</strong> <span class="tooltip-content-text">${
              point.name
            }</span></div>`;

            // Key-to-label mapping object

            if (matchingRegionData) {
              Object.keys(matchingRegionData.additionalData).forEach((key) => {
                if (matchingRegionData.additionalData[key] !== undefined) {
                  const label = keyLabels[key] || key;
                  tooltipContent += `<br/><strong>${label}:</strong> <span class="tooltip-content-text">${
                    matchingRegionData.additionalData[key] || 0
                  } ${key === "ptrSec" || key === "ptrUPry" ? "" : "%"}</span>`;
                }
              });
            }

            return tooltipContent;
          },
        },
      }));
    }
  }, [
    updateGrossEData,
    dashData,
    dashIntDataMap,
    MergeDataFromAllVariable,
    resetTrigger,
  ]);

  const setState = useCallback((stateName) => {
    const selectedState = stateIdData.stateData.find(
      (state) => normalize(state.stateName) === normalize(stateName)
    );

    console.log('selectedState', selectedState)
    if (selectedState) {
      setUdiceStateCode(selectedState?.udiseStateCode);
    }
    const selectedMapDisData = district_map.find(
      (data) => normalize(data.name) === normalize(stateName)
    );
    const upperCaseStateName = stateName.toUpperCase();
    localStorage.setItem("map_state_name", upperCaseStateName);
    localStorage.setItem("backstate", stateName);
    if (selectedMapDisData) {
      setMapOptions((prevOptions) => ({
        ...prevOptions,
        series: [
          {
            type: "map",
            joinBy: "id",
            mapData: selectedMapDisData.data[0].mapData,
            data: selectedMapDisData.data[0].mapData.map((district) => ({
              id: district.id,
              name: district.name,
              color: "#fff",
              borderColor: "#000000",
            })),
          },
        ],
        chart: {
          height: "480",
          marginTop: 25,
        },
        title: {
          text: "",
        },
        tooltip: {
          useHTML: true,
          backgroundColor: "#303841",
          style: {
            color: "white",
            fontSize: "14px",
          },
          // headerFormat: `State : ${selectedState}`,
          headerFormat: "",
          pointFormat: `<br/><strong>Districts:</strong> <span class="tooltip-content-text">{point.name}`,
        },
        plotOptions: {
          series: {
            allowPointSelect: true,
            cursor: "pointer",
          },
        },
      }));
    }
  });

  const resetToIndiaMap = () => {
    setMapOptions(intialMapOptions);
    setResetTrigger((prev) => !prev);
  };

  // useEffect to initialize map options
  useEffect(() => {
    if (resetMap) {
      resetToIndiaMap();
      setResetTrigger((prev) => !prev);
    }
  }, [resetMap]);
  const backToNational = () => {
    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
    dispatch(setBackstate("All India/National"));
    setBackstatesPreventApiCall("India");
    localStorage.setItem("backstate", nationalWiseName);
    localStorage.setItem("map_state_name", nationalWiseName);
    dispatch(fetchMaptatsData(modifiedFilterObjForReset));
    dispatch(fetchMaptatsOtherData(modifiedFilterObjForReset));
    dispatch(allFilter(modifiedFilterObjResetDashboard));
    handleAPIsCallAccordingToFilter(modifiedFilterObjResetDashboard);
    setUdiceStateCode("");
    dispatch(setIsIndiaClicked(false));
    resetToIndiaMap();
  };

  useEffect(() => {
    if (backstate !== "All India/National") {
      setState(backstate);
    }
  }, [backstate]);
// const headerAllReports=localStorage.getItem("headerNameForallReports")
//   useEffect(()=>{
// if(headerAllReports){
//   backToNational()
// }
//   },[headerAllReports,schoolFilter])
  useEffect(() => {
    if (isIndiaClicked === true) {
      if (selectedStateForCallAPI === nationalWiseName) {
      } else {
        /*--------------------Filter by Particular State ----------------------*/
        if (udiseStateCode) {
          filterObj.regionType = specificSWiseregionType;
          filterObj.regionCode = udiseStateCode;
          filterObj.dType = specificSWiseregionType;
          filterObj.dCode = udiseStateCode;
          filterObj.dashboardRegionType = specificSWiseregionType;
          filterObj.dashboardRegionCode = udiseStateCode;
          if (location.pathname !== "/") {
            filterObj.valueType = 1;
          } else {
            filterObj.valueType = 2;
          }
          dispatch(allFilter(filterObj));
          handleAPIsCallAccordingToFilter(filterObj);
        }
      }
    }
  }, [
    location.pathname,
    selectedStateForCallAPI,
    selectYearId,
    isIndiaClicked,
    schoolFilter,
    udiseStateCode,
  ]);
  const handleAPIsCallAccordingToFilter = (obj) => {
    if (headerSlice.headerName === "Education Dashboard") {
      dispatch(fetchDashboardData(obj));
      dispatch(fetchSchoolStatsData(obj));
      dispatch(fetchSchoolStatsIntData(obj));
      dispatch(fetchTeachersStatsData(obj));
      dispatch(fetchTeachersStatsIntData(obj));
      dispatch(fetchStudentStatsData(obj));
      dispatch(fetchStudentStatsIntData(obj));
    } else if (headerSlice.headerName === "School Dashboard") {
      dispatch(fetchSchoolStatsData(obj));
      dispatch(fetchSchoolStatsIntData(obj));
      dispatch(fetchArchiveServicesGraphSchoolData(obj));
    } else if (headerSlice.headerName === "Teacher Dashboard") {
      dispatch(fetchTeachersStatsData(obj));
      dispatch(fetchTeachersStatsIntData(obj));
    } else {
      dispatch(fetchStudentStatsData(obj));
      dispatch(fetchStudentStatsIntData(obj));
    }
  };
  return (
    <>
      {loading && (
        <Box className="map-overley">
          <CircularProgress />
        </Box>
      )}

      <div className="map-dropdown">
        {headerSlice.headerName === "Education Dashboard" && (
          <>
            {handleSchemesEvent === "gross_enrollment_ratio" && (
              <select
                value={selectedEnrollmentType}
                onChange={(e) => setSelectedEnrollmentType(e.target.value)}
                className="form-control"
              >
                <option value="middle">Middle</option>
                <option value="secondary">Secondary</option>
              </select>
            )}

            {handleSchemesEvent === "dropout_rate" && (
              <select
                value={selectedDropoutType}
                onChange={(e) => setSelectedDropoutType(e.target.value)}
                className="form-control"
              >
                <option value="preparatory">Preparatory</option>
                <option value="secondary">Secondary</option>
              </select>
            )}

            {handleSchemesEvent === "transition_rate" && (
              <select
                value={selectedTransitionRate}
                onChange={(e) => setSelectedTransitionRate(e.target.value)}
                className="form-control"
              >
                <option value="preparatoryToMiddle">
                  Preparatory to Middle
                </option>
                <option value="preparatoryMiddleToSec">
                  Middle to secondary
                </option>
              </select>
            )}

            {handleSchemesEvent === "pupil_teacher_ratio" && (
              <select
                value={selectedPupilTeacherRatio}
                onChange={(e) => setSelectedPupilTeacherRatio(e.target.value)}
                className="form-control"
              >
                <option value="pupilPreparatory">Preparatory</option>
                <option value="pupilMiddle">Middle</option>
              </select>
            )}
          </>
        )}

        {headerSlice.headerName === "School Dashboard" && (
          <>
            {handleSchemesEvent === "toilet" && (
              <select
                className="form-control"
                value={selectedToilet}
                onChange={(e) => setSelectedToilet(e.target.value)}
              >
                <option value="girls">Girls</option>
                <option value="boys">Boys</option>
              </select>
            )}
          </>
        )}

        {headerSlice.headerName === "Teacher Dashboard" && (
          <>
            {handleSchemesEvent === "nature_of_appointment" && (
              <select
                className="form-control"
                value={selectedNatureOfApponitmentType}
                onChange={(e) =>
                  setSelectedNatureOfApponitmentType(e.target.value)
                }
              >
                <option value="female">Female</option>
                <option value="male">Male</option>
              </select>
            )}

            {handleSchemesEvent === "trained_teacher_for_cwsn" && (
              <select
                className="form-control"
                value={selectedTrainedTeacherCWSNType}
                onChange={(e) =>
                  setSelectedTrainedTeacherCWSNType(e.target.value)
                }
              >
                <option value="female">Female</option>
                <option value="male">Male</option>
              </select>
            )}

            {handleSchemesEvent ===
              "teacher_trained_&_teaching_through_computer" && (
              <select
                className="form-control"
                value={selectedTrainedTeacherCompType}
                onChange={(e) =>
                  setSelectedTrainedTeacherCompType(e.target.value)
                }
              >
                <option value="female">Female</option>
                <option value="male">Male</option>
              </select>
            )}
          </>
        )}

        {headerSlice.headerName === "Student Dashboard" && (
          <>
            {handleSchemesEvent === "gender_parity_index" && (
              <select
                value={selectedGPIType}
                onChange={(e) => setSelectedGPIType(e.target.value)}
                className="form-control"
              >
                <option value="gpiprimary">Foundational</option>
                <option value="gpiUpperPrimary">Preparatory</option>
                <option value="elementary">Middle</option>
                <option value="gpiSecondary">Secondary</option>
              </select>
            )}

            {handleSchemesEvent === "dropout_ratio" && (
              <select
                value={selectedGERType}
                onChange={(e) => setSelectedGERType(e.target.value)}
                className="form-control"
              >
                <option value="gerDropoutUpperPrimary">Middle</option>
                <option value="gerDropoutSecondary">Secondary</option>
              </select>
            )}
          </>
        )}
      </div>

      <div className="graph-wrap" id="india-map">
        {backstate !== nationalWiseName && (
          <div className="buttonWrapper">
            <button className="backButton ms-3" onClick={backToNational}>
              <ArrowBackIcon /> National View
            </button>
          </div>
        )}
        <HighchartsReact
          constructorType={"mapChart"}
          highcharts={Highcharts}
          options={mapOptions}
          allowChartUpdate={true}
          immutable={true}
        />
      </div>
      <MapColorLabel />
    </>
  );
};

export default Map;
